/* eslint-disable react/no-array-index-key */
import React from 'react';
import { THit } from '@com/core/common/types/catalog';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import Link from '@com/core/common/components/Link';
import { getProductUrl } from '@com/core/common/utils/product';
import ProductBoxSlider from './ProductBoxSlider';

type TProps = {
    products: THit[];
};
const commonSpace = 12;

const HorizontalProductBoxCarousel = ({ products }: TProps): JSX.Element => {
    SwiperCore.use([Navigation]);
    return (
        <ProductBoxCarousel>
            <Swiper
                grabCursor
                spaceBetween={0}
                slidesPerView={3}
                slidesPerGroup={3}
                breakpoints={{
                    768: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                    },
                    992: {
                        slidesPerView: 6,
                        slidesPerGroup: 6,
                    },
                }}
                navigation={{
                    nextEl: '.swiper-button-next.swiper-button-white',
                    prevEl: '.swiper-button-prev.swiper-button-white',
                }}>
                {products.map((product: THit, i: number) => {
                    return (
                        <SwiperSlide key={`swiper-${i + 1}`}>
                            <Link href={`${getProductUrl(product, true)}`}>
                                <ProductBoxSlider product={product} />
                            </Link>
                        </SwiperSlide>
                    );
                })}
                <div className="swiper-button-next swiper-button-white custom-navigation" />
                <div className="swiper-button-prev swiper-button-white custom-navigation" />
            </Swiper>
        </ProductBoxCarousel>
    );
};

const ProductBoxCarousel = styled.div`
    padding: ${commonSpace}px;
    .swiper-wrapper {
    }
    .swiper-slide {
        height: auto;
        padding: 6px;
    }
    .custom-navigation {
        top: 50%;
        transform: translateY(-25%);
        height: 35px;
        width: 35px;
        border-radius: 100%;
        box-shadow: 0px 0px 3px -1px rgba(0, 0, 0, 0.5);
        border: 1px solid #ccc;
        background: rgba(255, 255, 255, 0.5);
        &:after {
            font-size: 18px !important;
            color: #000 !important;
            text-align: center !important;
        }
        &:hover {
            background: rgba(255, 255, 255, 0.9);
        }
    }

    .swiper-button-disabled {
        display: none;
    }

    .swiper-button-prev {
        ${({ theme: { isRTL } }): string => (isRTL ? 'right: 20px !important' : 'left: 20px !important')};
        background-image: none !important;
    }
    .swiper-button-next {
        ${({ theme: { isRTL } }): string => (isRTL ? 'left: 20px !important' : 'right: 20px !important')};
        background-image: none !important;
    }
`;

export default HorizontalProductBoxCarousel;
